import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../context/CartContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle } = FiIcons;

export default function Notification() {
  const { notification } = useCart();

  return (
    <AnimatePresence>
      {notification && (
        <motion.div
          initial={{ opacity: 0, y: 50, x: '-50%' }}
          animate={{ opacity: 1, y: 0, x: '-50%' }}
          exit={{ opacity: 0, y: 20, x: '-50%' }}
          className="fixed bottom-8 left-1/2 z-[200] bg-zinc-900 text-white px-8 py-4 flex items-center gap-4 shadow-2xl border border-zinc-800"
        >
          <SafeIcon icon={FiCheckCircle} className="text-green-500 text-xl" />
          <span className="font-bold uppercase tracking-widest text-xs">{notification}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}